'use client'

import { useEffect, useState } from 'react'
import ProductCard from '@/entities/ProductCard/index.js'
import { useDebounce } from '@/shared/hooks/useDebounce.js'
import { useGetCartItemsQuery } from '@/shared/api-rtk'
import { useGetProductCatalogMutation } from '@/shared/api-rtk/index.js'
import {
    AddToCart,
    AddToPreferences,
    QuickView,
} from '@/features/productSearch/ProductCardActions/index.js'
import { useProductSearchStore } from '@/features/productSearch/model/strore'
import LoaderPage from '@/shared/ui/LoaderPage/index.js'

export const ProductSearchPage = ({setMount}) => {
    const products = useProductSearchStore((store) => store.products)
    const { data: productsInCart } = useGetCartItemsQuery()
    const value = useProductSearchStore((state) => state.value)
    const setValue = useProductSearchStore((state) => state.setValue)

    const fetchProducts = useDebounce(
        useProductSearchStore((store) => store.fetchProducts),
        100
    )
    const [getProduct, { isLoading }] = useGetProductCatalogMutation()

    const [fullProducts, setFullProducts] = useState([])


    useEffect(() => {
        const searchQuery = localStorage.getItem('searchQuery')

        if (searchQuery) {
            fetchProducts(searchQuery)
            setValue(searchQuery)
        }
    }, [])

    useEffect(() => {
        const fullProductfetch = []

        products.map((product) => {
            getProduct(product.product_id)
                .unwrap()
                .then((res) => {
                    if (res.result === 'success') {
                        fullProductfetch.push(res.data)
                    }
                })
        })

        // localStorage.removeItem('searchQuery')
        setFullProducts(fullProductfetch)
        setMount(true)
    }, [products])

    return (
        <>
            {!value && (
                <span className="searchPage__result">
                    Введите ключевые слова в поиск
                </span>
            )}
            {value && !products.length && (
                <span className="searchPage__result">
                    Нет результатов поиска
                </span>
            )}
            <div className="searchPage">
                {fullProducts.map((product) => {
                    const firstKey = Object.keys(product)[0]
                    const item = product[firstKey]
                    return (
                        <ProductCard {...item} key={item.product_id}>
                            <QuickView
                                item={item}
                                productId={item.product_id}
                            />
                            <AddToPreferences
                                item={item}
                                productId={item.product_id}
                            />
                            <AddToCart
                                item={item}
                                productId={item.product_id}
                                cartContains={productsInCart.data.includes(
                                    item.product_id
                                )}
                            />
                        </ProductCard>
                    )
                })}
            </div>
        </>
    )
}
